export interface PerformanceValue {
    value: number | null | undefined;
    estimatedValue: number | null | undefined;
}

export function performanceRecordsHaveData(records: PerformanceValue[]): boolean {
    return (records || []).some(record => Number(record.value || 0) !== 0
        || Number(record.estimatedValue || 0) !== 0);
}
